export default __webpack_public_path__ + "img/accha/accha5_src.jpg";